<template>
    <div>
        <JetLabel value="Image"/>
        <div
            @dragover.prevent @drop.prevent="handleDrop"
            class="border-2 border-dashed rounded-lg p-4 flex flex-col items-center justify-center"
        >
            <img v-if="preview" :src="preview" class="w-48 h-48 object-cover rounded-lg mb-4" />

            <div v-else class="text-gray-400 py-10">Aucune image</div>

            <input
                ref="input"
                type="file"
                accept="image/*"
                class="hidden"
                @change="handleChange"
            />

            <div class="flex gap-3">
                <button type="button" @click="$refs.input.click()"
                    class="px-4 py-2 bg-sky-500 text-white rounded-md"
                >
                    Choisir une image
                </button>

                <button v-if="preview" type="button" @click="remove"
                    class="px-4 py-2 bg-red-500 text-white rounded-md"
                >Supprimer
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import JetLabel from '@/Jetstream/Label'

    export default {
        components:{
            JetLabel
        },

        props:{
            modelValue:{
                default:null
            },

            current:{
                type:String,
                default:null
            }
        },

        emits:['update:modelValue'],

        data(){
            return {
                preview:this.current || null
            }
        },

        watch:{
            current(value){
                this.preview=value
            }
        },

        methods:{
            handleChange(event){
                const file = event.target.files[0]

                if(!file){
                    return
                }

                this.setFile(file)
            },

            handleDrop(event){
                const file = event.dataTransfer.files[0]

                if(file){
                    this.setFile(file)
                }
            },

            setFile(file){
                if(!file.type.startsWith('image/')){
                    this.$swal.fire(
                        'Image',
                        'Le fichier doit être une image.',
                        'error'
                    )
                    return
                }

                this.$emit(
                    'update:modelValue',
                    file
                )

                if(this.preview){
                    URL.revokeObjectURL(
                        this.preview
                    )
                }

                this.preview = URL.createObjectURL(file)
            },

            remove(){
                this.preview=null

                this.$emit(
                    'update:modelValue',
                    null
                )

                if(this.$refs.input){
                    this.$refs.input.value=null
                }
            }
        }
    }
</script>